import { LuBarChart2, LuCompass, LuExternalLink, LuPencil } from 'react-icons/lu';
import { V2_TOKENS } from '../../tokens';
import styles from '../styles.module.scss';

const STEPS = [
    {
        number: 1,
        Icon: LuPencil,
        title: '4つの質問に答える',
        description: '物件の種類・場所・広さ・\n築年数を選ぶだけ',
    },
    {
        number: 2,
        Icon: LuBarChart2,
        title: 'すぐに結果を見る',
        description: 'その場で相場価格が\nすぐにわかります',
    },
    {
        number: 3,
        Icon: LuCompass,
        title: '次のステップを選ぶ',
        description: '売る・貸す・保つなど\n自分のペースで決められます',
    },
];

type FlowSectionProps = {
    flowDetailUrl: string;
};

export const FlowSection = ({ flowDetailUrl }: FlowSectionProps) => {
    return (
        <section className={styles.flowSection}>
            <h2 className={styles.sectionTitle}>査定のながれ</h2>
            <p className={styles.sectionSubtitle}>3ステップで完了。難しい手続きはありません。</p>

            <div className={styles.stepsRow}>
                {STEPS.map((step) => {
                    const Icon = step.Icon;
                    return (
                        <div key={step.number} className={styles.stepCard}>
                            <div className={styles.stepNumber}>{step.number}</div>
                            <div className={styles.stepIcon}>
                                <Icon size={28} color={V2_TOKENS.color.textSecondary} />
                            </div>
                            <h3 className={styles.stepTitle}>{step.title}</h3>
                            <p className={styles.stepDesc}>{step.description}</p>
                        </div>
                    );
                })}
            </div>

            <a
                href={flowDetailUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.flowLink}
            >
                査定の流れをくわしく見る
                <span className={styles.flowLinkIcon}>
                    <LuExternalLink size={14} color="currentColor" />
                </span>
            </a>
        </section>
    );
};
